module.exports = [{"id":1,"name":"白"},{"id":2,"name":"绿"},{"id":3,"name":"蓝"},{"id":4,"name":"紫"},{"id":5,"name":"橙"},{"id":6,"name":"红"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/plrz_ability_quality.json
// module id = 1Kuz
// module chunks = 1